module.exports = __webpack_public_path__ + "static/media/home-screen-footer.7c05556b.png";